export default __webpack_public_path__ + "maps-examples-view-annotation-basic-1200-c7a617fce4a2ba431ab4bfc5e4e3f881.webp";